import React, { use } from "react";
import { ProductCard } from "../../components";
import { Product, Transaction } from "../../types/Product";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useProduct } from "../../hooks/useProduct";
import { useTransaction } from "../../hooks/useTransaction";
import { Alert, Snackbar } from "@mui/material";

const Home: React.FC = () => {
  const { products } = useProduct();
  const { addTransaction } = useTransaction();

  const [cart, setCart] = React.useState<Record<string, number>>({});
  const [snackbarOpen, setSnackbarOpen] = React.useState<boolean>(false);

  const total = React.useMemo(() => {
    return Object.entries(cart).reduce((sum, [id, number]) => {
      const product = products.find((product) => product.id === id);
      return sum + (product?.price || 0) * number;
    }, 0);
  }, [cart, products]);
  const handleChange = (
    id: string,
    actions: "add" | "minus",
    number: number,
  ) => {
    console.log(id, actions, number);
    setCart((prevCart: any) => {
      const currentNumber = prevCart[id] || 0;
      const newNumber =
        actions === "add" ? currentNumber + number : currentNumber - number;
      if (newNumber === 0) {
        const newCart = { ...prevCart };
        delete newCart[id];
        return newCart;
      }

      return {
        ...prevCart,
        [id]: newNumber > 0 ? newNumber : 0,
      };
    });
  };
  const handleClear = () => {
    setCart({});
  };
  const handleCheckout = () => {
    console.log("checkout", cart);
    const date = new Date();
    const order: Transaction = {
      id: date.getTime(),
      date: date.getTime(),
      items: Object.entries(cart).map(([id, number]) => {
        const product = products.find((product) => product.id === id);
        return {
          id,
          name: product?.name || "",
          price: product?.price || 0,
          number,
        };
      }),
      total,
    };
    console.log("order", order);

    addTransaction(order);
    setCart({});
    setSnackbarOpen(true);
  };

  React.useEffect(() => {
    console.log("cart changed", cart);
  }, [cart]);
  return (
    <Paper sx={{ p: 3, mb: 5 }}>
      <Typography variant="h5" align="center" gutterBottom>
        商品
      </Typography>

      {products.length === 0 ? (
        <Box textAlign="center" py={6}>
          <Typography color="text.secondary">沒有商品</Typography>
        </Box>
      ) : (
        <Box className="justify-center grid grid-cols-[repeat(auto-fit,minmax(120px,120px))] gap-2">
          {products.map((product) => (
            <ProductCard
              key={product.id}
              product={product}
              number={cart[product.id] || 0}
              handleChange={handleChange}
            />
          ))}
        </Box>
      )}

      {Object.keys(cart).length > 0 && (
        <Paper
          elevation={3}
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 1400,
          }}
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            px={1}
            py={0.5}
          >
            <Box display="flex" alignItems="center" gap={1}>
              <Typography color="text.secondary">總數：</Typography>
              <Typography fontWeight={600}>${total.toFixed(2)}</Typography>
            </Box>

            <Box display="flex" gap={1}>
              <Button
                size="small"
                color="error"
                variant="outlined"
                onClick={handleClear}
              >
                清空
              </Button>
              <Button
                size="small"
                color="primary"
                variant="contained"
                onClick={handleCheckout}
              >
                結帳
              </Button>
            </Box>
          </Box>
        </Paper>
      )}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={1500}
        message="結帳成功"
        onClose={() => setSnackbarOpen(false)}
      >
        <Alert severity="success" variant="filled" sx={{ width: "100%" }}>
          結帳成功
        </Alert>
      </Snackbar>
    </Paper>
  );
};

export default Home;
